import React from 'react'
import styles from './styles.module.scss'
import classNames from 'classnames'
import { getMTODeliveryDate } from '@components/product/mto/helpers'
import { FulfillmentLocation } from 'types/product'

type FulfillmentConfig = {
  dispatchDays: number
  labelPrefix: string
}

type FulfillmentInfoProps = {
  createdAt?: string
  fulfillment: FulfillmentConfig
  classes?: string
}

export function getFulfillmentConfig({
  fulfillmentLocation,
  talDispatchDays
}: {
  fulfillmentLocation?: FulfillmentLocation
  talDispatchDays?: number | null
}): FulfillmentConfig | null {
  if (fulfillmentLocation === 'TAL' && talDispatchDays) {
    return {
      dispatchDays: talDispatchDays,
      labelPrefix: 'Estimated dispatch by'
    }
  }

  return null
}

function FulfillmentInfo({
  createdAt,
  fulfillment,
  classes
}: FulfillmentInfoProps) {
  return (
    <p className={classNames(styles.mtoDispatch__info, classes)}>
      <strong className={styles.mtoDispatch__title}>Made to Order:</strong>{' '}
      {fulfillment.labelPrefix}{' '}
      {getMTODeliveryDate(createdAt, fulfillment.dispatchDays)}
    </p>
  )
}

export default FulfillmentInfo
